export function getServerUrl(){
    return "https://www.hexinst.com:8080/";
    // return "localhost:8080/";
}